export const stepContent: Record<number, any> = {
  1: {
    title: "Step 1: Prepare the data file with right format",
    description:
      "To input multiple accounts and parameters, you need to upload the file with correct format. In case of any issues, please download and use our template.",
  },
  2: {
    title: "Step 2: Upload file",
    description:
      "We only support Excel or CSV format now. Please make sure the file contains the required data.\nIn case of any issues, please download and use our template.",
  },
  3: {
    title: "Step 3: Preview paramater",
    description:
      "Please determine if the following parameter can be used for campaign filter. Maximum of 9 parameters can be selected.",
  },
  4: {
    title:
      "Please determine if the following parameter can be used for campaign filter. Maximum of 9 parameters can be selected.",
    description: `We have highlighted all errors in your uploaded file. You can download it, make the correction, and upload it again or ignore them and proceed with the remaining\nsuccessful entries by clicking on the <b>Submit</b> button.`,
  },
};

export const dataTemplate = [
  {
    dataName: "Customer Name",
    description: "Used to identify the customer by name",
  },
  {
    dataName: "Customer ID",
    description: "Used to identify the customer by ID",
  },
  {
    dataName: "Customer Mobile No.",
    description: "Used to contact the customer when required",
  },
];

export const dataSetp3 = [
  {
    name: "Customer Name",
    type: "String",
    campaignFilter: false,
    mandatory: "Yes",
  },
  {
    name: "Customer ID",
    type: "String",
    campaignFilter: false,
    mandatory: "Yes",
  },
  {
    name: "Customer Mobile No",
    type: "String",
    campaignFilter: false,
    mandatory: "Yes",
  },
];

export const rulesTemplate = [
  {
    dataType: "String",
    format: "-",
    minLength: "1",
    maxLength: "255",
    alphabets: "Yes",
    number: "No",
    alphanumeric: "Yes",
  },
  {
    dataType: "Date",
    format: "DD-MMM-YYYY",
    minLength: "N/A",
    maxLength: "N/A",
    alphabets: "N/A",
    number: "N/A",
    alphanumeric: "N/A",
  },
  {
    dataType: "Amount",
    format: "10,2",
    minLength: "0.01",
    maxLength: "9,999,999,999.99",
    alphabets: "No",
    number: "Yes",
    alphanumeric: "No",
  },
  {
    dataType: "Integer",
    format: "10,0",
    minLength: "1",
    maxLength: "9,999,999,999",
    alphabets: "No",
    number: "Yes",
    alphanumeric: "No",
  },
  {
    dataType: "Float",
    format: "10,2",
    minLength: "-9,999,999,999",
    maxLength: "9,999,999,999",
    alphabets: "No",
    number: "Yes",
    alphanumeric: "No",
  },
  {
    dataType: "ListCode",
    format: "-",
    minLength: "1",
    maxLength: "5",
    alphabets: "Yes",
    number: "Yes",
    alphanumeric: "Yes",
  },
  {
    dataType: "ListDesc",
    format: "-",
    minLength: "3",
    maxLength: "255",
    alphabets: "Yes",
    number: "Yes",
    alphanumeric: "Yes",
  },
];
